// extracted by mini-css-extract-plugin
export var hideEditor = "_j8-2";
export var infoIcon = "_j8-3";
export var label = "_j8-1";
export var labelContainer = "_j8-0";
export var readonlyText = "_j8-4";